export const RemovedList = ({ removedUsers, pendingRemovedUsers = [], eventUsers, movers = [], sitters = [], eventId }) => {

  // Combine DB removed users and pending removed users, keeping track of pending status
  const combineAndClassify = (dbRemovedGroup, pendingAll, originalGroup) => {
    const combined = new Map();

    // Add DB removed users
    (dbRemovedGroup || []).forEach(userId => {
      if (!combined.has(userId)) {
        combined.set(userId, { id: userId, pending: false });
      }
    });

    // Add pending users, checking if they belong to the original group
    pendingAll.forEach(userId => {
      if (originalGroup.includes(userId)) {
        if (combined.has(userId)) {
          // If already present from DB list, mark as pending (this case might be unlikely but handles overlap)
          combined.get(userId).pending = true;
        } else {
          combined.set(userId, { id: userId, pending: true });
        }
      }
    });

    return Array.from(combined.values());
  };

  const combinedMovers = combineAndClassify(removedUsers?.movers, pendingRemovedUsers, movers);
  const combinedSitters = combineAndClassify(removedUsers?.sitters, pendingRemovedUsers, sitters);

  const renderUserList = (users, title) => (
    <ul className="w-1/2 text-sm text-center font-medium bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg">
      <li className="w-full px-4 py-2 border-b border-gray-200 dark:border-gray-700 rounded-t-lg text-white bg-red-300">
        {title}
      </li>
      {users.map((user, index) => (
        <li
          key={eventUsers[user.id]?.userID || user.id} // Use user.id and fallback
          className="w-full px-4 py-2 border-b border-gray-200 dark:border-gray-700 text-slate-700 dark:text-slate-200 text-nowrap text-ellipsis overflow-hidden"
        >
          {index + 1}. {eventUsers[user.id]?.name || "Unknown"}
          {user.pending && <span className="text-xs text-orange-500 dark:text-orange-400 ml-1">(pending)</span>} {/* Add pending indicator */}
        </li>
      ))}
      {users.length === 0 && (
        <li className="w-full px-4 py-2 border-b border-gray-200 dark:border-gray-700 text-slate-400 dark:text-slate-500 italic">
          None
        </li>
      )}
    </ul>
  );

  return (
    <div className="flex gap-4">
      {/* Only render if there are movers to show */}
      {(combinedMovers.length > 0) && renderUserList(combinedMovers, "Movers")}
      {/* Only render if there are sitters to show */}
      {(combinedSitters.length > 0) && renderUserList(combinedSitters, "Sitters")}
    </div>
  );
};
